import { handleError } from './Actions'
import { put } from '../../calculator/lib/xhr'
import { ActionTypes as types } from '../constants'

export function changeUnilateralName(name) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_NAME,
    data: { name },
  }
}

export function changeUnilateralCountryCode(countryCode) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_COUNTRY_CODE,
    data: { countryCode },
  }
}

export function resendMail(transactionId) {
  return dispatch => {
    dispatch({
      type: types.UNILATERAL.RESEND_MAIL_STATUS,
      data: { status: 'processing' },
    })
    const url = '/myaccount/transfer/resend-mail'
    const params = { transactionId }
    return put(url, params)
      .then(resp => {
        if (resp.data.sendNotification && resp.data.sendNotification.status) {
          dispatch({
            type: types.UNILATERAL.RESEND_MAIL_STATUS,
            data: { status: 'success' },
          })
          return resp.body.sendNotification
        }

        dispatch({
          type: types.UNILATERAL.RESEND_MAIL_STATUS,
          data: { status: 'initial' },
        })

        return { status: false }
      })
      .catch(handleError(dispatch))
  }
}
